import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class StJeanSurRichelieu extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription">
                    <h1>{DojoRepository.ST_JEAN_SUR_RICHELIEU.name}</h1>
                    <p>Sensei Marc Lacoursière a débuté la pratique du Karaté Shotokan en 1975 et celle du Taï Chi Chuan en 1990 et c'est avec passion qu'il offre des cours privés ou semi-privés dans son dojo ISKF (International Shotokan Karate Federation) où chaque élève peut pratiquer, à son rythme, l'art qui lui convient le mieux dans une ambiance Zen et bénéficier d'un enseignement de qualité où s'harmonisent l'esprit et le corps.</p>
                    <p>Le dojo ISKF de Sensei Marc Lacoursière est situé dans le secteur de St-Luc, à St-Jean-sur-Richelieu, au sous-sol de sa résidence. Cette localisation particulière lui permet d'offrir une plus grande disponibilité et de s'adapter aux horaires variables de ses karatékas.</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                    <p>Sensei Marc Lacoursière a oeuvré pendant plusieurs années comme professeur de philosophie. Préoccupé par les motifs inconscients de l'agir humain, il s'est spécialisé en psychanalyse mais aussi dans l'étude des principaux fleurons de la sagesse orientale, comme l'Hindouisme, le Bouddhisme, le Taoisme ainsi que le Zen (Chan) issu de la rencontre du Bouddhisme et du Taoïsme.</p>
                    <p>Retraité de l'enseignement depuis 2006, Sensei Marc Lacoursière, 3ième dan, consacre sa vie à ses trois passions qui sont la relation d'aide, l'enseignement et la pratique du Karaté Shotokan et l'enseignement du Tai Chi Chuan, méthode Yang.Il a agi à titre d'assistant instructeur au dojo Québec Hoïtsugan de Montréal de 1985 à 1988, de même que pour le service des sports du CÉGEP de Saint-Jean-sur-Richelieu de 1986 à 1995.Il a enseigné également de 1997 à 2002 au Dojo Goshinkan de Saint-Jean-sur-Richelieu.</p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Instructeur en chef</strong><br />
                        Marc Lacoursière - 3e Dan
                    </p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                    <p>Disponibilités selon la demande et suite à entente préalable, les cours peuvent être le matin le midi ou le soir. Flexible. Les cours se donnent du lundi au samedi inclusivement.</p>
                    <p>Aussi, cours de Tai Chi.</p>
                    <p>Les cours sont adaptés selon les grades et les capacités physiques des élèves.</p>
                    <p>Un vendredi par mois, cours pour tous.</p>
                </section>
                <p>&nbsp;</p>

                <section id="taiChiChuan"> 
                    <h1>Tai Chi Chuan</h1>
                    <p>Pour plus d'information sur notre offre concernant le Tai Chi Chuan, nous vous invitons à consulter notre site web didié à cette discipline :</p>
                    <p><a href="http://www.tai-chi-chuan.ca/Yang_Chuan_-_Marc_Lacoursiere.html" target="_blank" rel="noopener noreferrer">Informations sur le Tai Chi Chuan</a></p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoPrices"> 
                    <h1>Tarifs</h1>
                    <table border="1" class="price-table" cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs à la carte (coûts par cours)</td>
                            </tr>
                            <tr>
                                <td class="description-column">Tous</td>
                                <td class="price-column">12$/cours</td>
                            </tr>
                        </tbody>
                    </table>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>ISKF St-Jean-sur-Richelieu</strong><br />
                        11 rue Louis Liénard de Beaujeu<br />
                        St-Jean-sur-Richelieu, QC<br />
                        J2W 1T4<br />
                        <a href={DojoRepository.ST_JEAN_SUR_RICHELIEU.links.googleMaps} target="_blank" rel="noopener noreferrer" title="Dojo ISKF St-Jean">Google Maps</a>
                    </p>
                    <p>
                        <strong>Marc Lacoursière</strong><br />
                        (450) 348-9862<br />
                        marc.lacoursiere@quebeciskf.com
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.ST_JEAN_SUR_RICHELIEU.geo}>
                        <Marker position={DojoRepository.ST_JEAN_SUR_RICHELIEU.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(StJeanSurRichelieu)



// WEBPACK FOOTER //
// ./src/pages/dojo/StJeanSurRichelieu.js